// JSON 字符串清洗工具

/**
 * sanitizeJsonString
 * 将传入的 JSON 字符串做保守清洗，目的是去除会导致解析失败或后续处理异常的不可见控制字符。
 * 清洗策略：
 * - 删除字面上的转义 NUL 序列 "\\u0000" 和 "\\0"（有些上位机会以转义形式传输 NUL）
 * - 删除实际存在的控制字符范围 U+0000..U+001F 以及 DEL(U+007F)
 * - 保留 JSON 合法的转义序列（如 \n, \r, \t 等）
 * - 最后进行 trim 去除首尾空白
 *
 * 备注：此函数为保守清理，可能会删除字段中本不应该出现的控制字符——通常这是上位机传输数据中的问题，
 * 建议从上位机侧修复数据源。如果需要更精确的清洗（例如只清洗 `mouseSn` 字段），可以改为只对该字段执行清洗。
 */
export function sanitizeJsonString(input) {
  if (input == null) return input;
  let str = String(input);
  const original = str;
  

  
  // 移除字面上的转义 NUL 序列（这些是有问题的）
  str = str.replace(/\\u0000/g, "");
  str = str.replace(/\\0/g, "");
  
  // 移除实际的控制字符（包括 NUL）和 DEL
  // 注意：这里只删除真正的控制字符（ASCII 0-31 和 127），不删除转义序列
  str = str.replace(/[\u0000-\u001F\u007F]+/g, "");
  
  str = str.trim();
  
  // 打印清洗结果
  if (str !== original) {
    console.log('[JSON清洗] 开始清洗，原始数据:', original);
    console.log('[JSON清洗] 数据已清洗，清洗后:', str);
  }
  
  return str;
}

export default {
  sanitizeJsonString,
};
